module.exports = __webpack_public_path__ + "static/media/white-small.5d3b7c96.svg";


//////////////////
// WEBPACK FOOTER
// ./public/images/white-small.svg
// module id = 1637
// module chunks = 1